import { cn } from '@/lib/utils';
import type { JobStatus } from '@/lib/types';

interface JobStatusBadgeProps {
  status: JobStatus;
  pulse?: boolean;
}

const statusConfig: Record<
  JobStatus,
  { label: string; className: string; pulseClassName?: string }
> = {
  pending: {
    label: 'Pending',
    className: 'bg-slate-500/10 text-slate-500 border-slate-500/30',
  },
  running: {
    label: 'Running',
    className: 'bg-blue-500/10 text-blue-500 border-blue-500/30',
    pulseClassName: 'animate-pulse',
  },
  completed: {
    label: 'Completed',
    className: 'bg-green-500/10 text-green-500 border-green-500/30',
  },
  failed: {
    label: 'Failed',
    className: 'bg-red-500/10 text-red-500 border-red-500/30',
  },
  cancelled: {
    label: 'Cancelled',
    className: 'bg-amber-500/10 text-amber-500 border-amber-500/30',
  },
  expired: {
    label: 'Expired',
    className: 'bg-red-900/10 text-red-400 border-red-900/30',
  },
  retry_pending: {
    label: 'Retry Pending',
    className: 'bg-yellow-500/10 text-yellow-500 border-yellow-500/30',
  },
};

export default function JobStatusBadge({ status, pulse = true }: JobStatusBadgeProps) {
  const config = statusConfig[status];
  const shouldPulse = pulse && status === 'running';

  return (
    <span
      className={cn(
        'inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium border',
        config.className,
        shouldPulse && config.pulseClassName
      )}
    >
      {status === 'running' && (
        <span className="mr-1.5 h-1.5 w-1.5 rounded-full bg-blue-500" />
      )}
      {config.label}
    </span>
  );
}
